// extracted by mini-css-extract-plugin
export var standaloneTable = "_f2-0";
export var standaloneTableWithBodyFill = "_f2-1";
export var withExtraHeader = "_f2-2";